import { push } from 'connected-react-router'
import getSearchByTireSizeUrl, { getSearchByTireSizeUrlFromVehicle } from 'helpers/getSearchByTireSizeUrl'

export const navigateToSearchByTireSizes = (tireSize = {}, extraQueryParams, isTrailer) =>
  push(
    tireSize.frontTireSize ? // it's an indicator that we pass sizes from activeVehicle rather than redux tire size.
      getSearchByTireSizeUrlFromVehicle({ activeVehicle: tireSize, extraQueryParams, isTrailer }) :
      getSearchByTireSizeUrl(tireSize, extraQueryParams, isTrailer)
  )
